import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import './css/breadcrumb.css';
import { Store } from '../../Store';

const Breadcrumb = () => {
  const { state } = useContext(Store);
  const { resentBread } = state;
  return (
    <section className="bg-breadcrumb ">
      <div className="container">
        <div className="row breadcrumb">
          <div className="col-12">
            <div className="d-flex icon mt-auto">
              <i className="fas fa-home" style={{ fontSize: '20px' }}></i>
              <div className="link">
                <Link className="link-breadcrumb" to="/" title="Trang chủ">
                  Trang chủ
                </Link>
                {resentBread &&
                  resentBread.map(
                    (breadcrumb, idx) =>
                      breadcrumb.title && (
                        <span key={idx}>
                          /
                          <Link
                            className="link-breadcrumb"
                            to={resentBread.length <  idx ? `${breadcrumb.slug}` : "#"}
                            title={breadcrumb.title}
                          >
                            {breadcrumb.title}
                          </Link>
                        </span>
                      )
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Breadcrumb;
